import React, { useState, useEffect } from "react";
import useQuery from "../../../shared/functions/functions";
import PasswordResetTokenNotValid from "../../components/reset-password/token-not-valid/index";
import ResetPasswordForm from "../../components/reset-password/reset";
import axios from "../../../config/axios/axios";
import { Redirect } from "react-router-dom";

function ResetPasswordPrivate() {
  const query = useQuery();
  const verificationToken = query.get("verificationToken");
  const [tokenExpired, setVerificationTokenExpired] = useState(false);
  const [token] = useState(verificationToken);

  useEffect(() => {
    validateToken(token);
  }, []);

  if (!token) {
    return (
      <div>
        <Redirect to={"/page-not-found"} />
      </div>
    );
  }

  if (tokenExpired) {
    return <PasswordResetTokenNotValid />;
  }

  return (
    <div>
      <ResetPasswordForm type={"private"} token={token} />
    </div>
  );

  function validateToken(token) {
    axios
      .get(`client/private/reset-password`, { params: { token: token } })
      .then((response) => {
        if (response.data === true) {
          setVerificationTokenExpired(false);
        } else {
          setVerificationTokenExpired(true);
        }
      })
      .catch((error) => {
        setVerificationTokenExpired(true);
      });
  }
}

export default ResetPasswordPrivate;
